import i18n from 'src/i18n';

const t = key => i18n.t(key);

export default {
    name: [
        {
            required: true,
            get message() {
                return t('请设置接待组件名称');
            },
            trigger: 'change',
        },
    ],
    roleWX: [
        {
            required: true,
            get message() {
                return t('请选择员工');
            },
            trigger: 'input',
        },
    ],
    image: [
        {
            required: true,
            get message() {
                return t('请选择客服形象');
            },
            trigger: 'change',
        },
    ],
    url: [
        {
            validate: (value, rules, allValue) => {
                if (value || allValue.deployRemarks0 !== '') {
                    // eslint-disable-next-line no-useless-escape
                    const reg = /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
                    if (!reg.test(value)) {
                        return false;
                    }
                }
                return true;
            },
            get message() {
                return t('请输入有效的url');
            },
            trigger: 'change',
        },
    ],
    deployRemarks: [
        {
            validate: (value, rules, allValue) => {
                // 链接填写了，但是备注名没写
                if (value === '' && allValue.deployWebsite0) {
                    return false;
                }
                // 如果是第一条数据空值可以让他提交
                if (allValue.deployRemarks0 === '') {
                    return true;
                }
                if (!value) {
                    return false;
                }
                return true;
            },
            get message() {
                return t('请填写备注名称');
            },
            trigger: 'change',
        },
    ],
};
